import React, {Component} from "react";
import moment from "moment/moment";
import EmojiPicker from 'emoji-picker-react';
import {CreateWebSocket} from "../web-socket"
import {HttpClient} from "../http-client";
import {toast} from "react-toastify";
import {Upload} from "antd";
import {IMG_MESSAGE_HOST} from "../../../helper/host";
import ImgCrop from "antd-img-crop";
import close from "../../../assets/icon/close.svg";
import emoji from "../../../assets/icon/emoji.svg";
import read from "../../../assets/icon/read.svg";
import attach from "../../../assets/icon/attach.svg";
import send from "../../../assets/icon/send.svg";
import unread from "../../../assets/icon/unread.svg"
import arrowUp from "../../../assets/icon/arrow-up.svg";
import arrowDown from "../../../assets/icon/arrow-down.svg";
import Modal from "../../Perusahaan/components/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Button1} from "../../Perusahaan/components/Button/button";
import CreatableSelect from 'react-select/creatable';
import customToast from "../../../notification/customToast";

export class ChatCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataConversation: this.props.conversation,
            dataParticipants: this.props.participants,
            text            : '',
            image           : {},
            fileList        : [],
            socketRef       : null,
            typingTimeoutRef: null,
            retryCountRef   : 0,
            messagesEndRef  : null,
            rows            : 1,
            minRows         : 1,
            maxRows         : 3,
            messagesData    : [],
            customerId      : false,
            openFile        : false,
            openEmot        : false,
            isSending       : false,
            isTyping        : false,
            messageAccount  : {},
            openShortMessage: false,
            addShortMessage : false,
            dataShortMessage: [],
            message_id      : "",
            message_short   : "",
        };

        this.socketRef          = React.createRef();
        this.typingTimeoutRef   = React.createRef();
        this.retryCountRef      = React.createRef();
        this.messagesEndRef     = React.createRef();
    }

    componentDidMount() {
        const { conversation, participants } = this.props;

        const token = localStorage.getItem("Presensi-message-token");

        if (token) {
            const user = localStorage.getItem("Presensi-message-user");
            if (user) {
                this.setState({
                    messageAccount: JSON.parse(user),
                });
            }
            this.socketChats(conversation.id, token);
        }

        this.setState({ archived: conversation.archived });

        const receiver = participants.find(participant => participant.role === 'sender');
        if (receiver) {
            this.getCustomer(receiver);
        }

        this.cleanupSocket = () => {
            if (this.socketRef?.current) {
                this.props.handleChangeOnline(conversation.id, false);
                this.props.handleReadMessage(conversation.id);
                this.socketRef.current.close();
                this.retryCountRef.current = this.maxRetries;
            }
        };

        if (this.props.registerSocketChats) {
            this.props.registerSocketChats(this.socketChats);
        }

        this.getShortMessage();
    }

    componentWillUnmount() {
        if (this.cleanupSocket) {
            this.cleanupSocket();
        }
    }

    toggleModal() {
        this.setState({
            addShortMessage : false
        })
    };

    handleInputChange = (e) => {
        const textareaLineHeight = 24;
        const { dataParticipants, minRows, maxRows } = this.state;

        const sender = dataParticipants.find((p) => p.role === "receiver");
        const senderId = sender?.userID || "";

        const previousRows = e.target.rows;
        e.target.rows = minRows;

        const currentRows = Math.floor(e.target.scrollHeight / textareaLineHeight);

        if (currentRows === previousRows) {
            e.target.rows = currentRows;
        }

        if (currentRows >= maxRows) {
            e.target.rows = maxRows;
            e.target.scrollTop = e.target.scrollHeight;
        }

        this.setState({
            text: e.target.value,
            rows: currentRows < maxRows ? currentRows : maxRows,
        });

        if (this.socketRef?.current && this.socketRef.current.readyState === WebSocket.OPEN) {
            this.socketRef.current.send(
                JSON.stringify({
                    type: "typing",
                    sender: senderId,
                    isTyping: true,
                })
            );
        }

        if (this.typingTimeoutRef.current) {
            clearTimeout(this.typingTimeoutRef.current);
        }

        this.typingTimeoutRef.current = setTimeout(() => {
            if (this.socketRef?.current && this.socketRef.current.readyState === WebSocket.OPEN) {
                this.socketRef.current.send(
                    JSON.stringify({
                        type: "typing",
                        sender: senderId,
                        isTyping: false,
                    })
                );
            }
        }, 2000);
    };

    handleEmojiClick = (emojiData) => {
        const emoji = emojiData.emoji || emojiData.native || emojiData;
        this.setState(prevState => ({
            text: prevState.text + emoji
        }));
    }

    handleAdd = (inputValue) => {
        const reqData = {
            message: inputValue
        };

        this.props.request("admin/message-short/add", reqData, "POST")
            .then((res) => {
                if (res.success) {
                    const savedItem = res.data;
                    this.setState((prev) => ({
                        dataShortMessage: [...prev.dataShortMessage, savedItem]
                    }));
                    this.getShortMessage();
                } else {
                    customToast.error("Gagal menambahkan pesan");
                }
            });
    }

    handleDelete = (removedOption) => {
        const reqData = {
            message_id: removedOption
        };

        this.props.request("admin/message-short/delete", reqData, "POST")
            .then((res) => {
                if (res.success) {
                    customToast.error(res.message);
                } else {
                    customToast.error(res.message);
                }
            });
    }

    getCustomer = async (receiver) => {
        const customer = await HttpClient(`/customers/${receiver.userID._id}`, "GET");

        if (customer.success) {
            this.setState({
                customerId : customer.data.customerID
            });
        }
    }

    cleanUpSend = async () => {
        this.setState({
            text: "",
            image: {},
            fileList: [],
            isSending: false,
            openFile: false,
            openEmot: false
        })
    };

    sendChat = (messageText) => {
        const { conversation } = this.props;
        const { text, image } = this.state;

        const textMessage = messageText || text;

        if (!textMessage.trim() && !image?.file) return;

        const formData = {
            conversationId: conversation.id,
            text: textMessage
        };

        if (image?.file) {
            formData.images = [image.file];
        }

        this.setState({ isSending: true });

        HttpClient("/chats", "POST", formData)
            .then((response) => {
                if (response.success) {
                    this.setState({
                        text: "",
                        image: {},
                        fileList: [],
                        isSending: false,
                        openFile: false,
                        openEmot: false
                    });

                    this.socketChats(conversation.id, this.props.token);
                }
            })
            .catch((error) => {
                toast.error("Error sending chat: " + error.message);
            });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.messagesData !== this.state.messagesData) {
            this.scrollToBottom();
        }
    }

    scrollToBottom = () => {
        if (this.messagesEndRef.current) {
            this.messagesEndRef.current.scrollIntoView({ behavior: "auto" });
        }
    };

    socketChats = async (id, token) => {
        if (!id || !token) return;

        const params = { conversationId: id };
        const URL = await CreateWebSocket("chats/ws", token, params);
        const socket = new WebSocket(URL);

        this.socketRef.current = socket;

        socket.onopen = () => {
            this.retryCountRef.current = 0;
            this.setState({
                messagesData: [],
                openFile: false,
                openEmot: false,
                openShortMessage: false,
                fileList: [],
                text: ""
            });
        };

        socket.onmessage = (event) => {
            try {
                const receivedMessage = JSON.parse(event.data);

                switch (receivedMessage.type) {
                    case 'initial_chat':
                        this.setState({
                            messagesData: receivedMessage.data
                        });
                        break;

                    case 'chat_created':
                        if (this.props.conversation?.id === receivedMessage.data._id) {
                            this.props.handleReadMessage(receivedMessage.data._id);
                        }

                        this.setState((prevState) => ({
                            messagesData: [receivedMessage.data, ...prevState.messagesData]
                        }));
                        break;

                    case 'conversation_updated':
                        if (this.props.conversation.id === receivedMessage.data._id) {
                            const { data } = receivedMessage;
                            const isOnline = this.props.conversation?.isOnline || false;

                            this.props.setNewConversation({
                                id: data._id,
                                status: data.status,
                                archived: data.isArchived,
                                isOnline,
                                lastChatDate: data.lastChatDate,
                            });
                        }
                        break;

                    case 'typing':
                        if (receivedMessage.sender === this.props.typingSender) {
                            this.setState({ isTyping: receivedMessage.isTyping });
                        }
                        break;

                    default:
                        break;
                }
            } catch (error) {
                console.error("WebSocket message parsing error:", error);
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
            if (this.retryCountRef.current < this.maxRetries) {
                const delay = Math.min(1000 * Math.pow(2, this.retryCountRef.current), this.retryDelay);
                setTimeout(() => {
                    this.retryCountRef.current += 1;
                    this.socketChats(id, token);
                }, delay);
            }
        };
    };

    isSender = (id) => {
        return this.state.messageAccount.id === id;
    };

    getTimeFromMessage = (date) => {
        const sendedAtDate = new Date(date);
        return sendedAtDate.toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    groupMessagesByDay (messages){
        if (!Array.isArray(messages)) {
            return {};
        }

        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Agu",
            "Sep",
            "Okt",
            "Nov",
            "Des",
        ];

        const dayNames = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];

        return messages.reduce((acc, message) => {
            const currentDate = new Date();
            const messageDate = new Date(message.createdAt);

            const currentDateMidnight = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate()
            );
            const messageDateMidnight = new Date(
                messageDate.getFullYear(),
                messageDate.getMonth(),
                messageDate.getDate()
            );

            const diffTime = currentDateMidnight - messageDateMidnight;
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            let dateLabel;
            if (diffDays === 0) {
                dateLabel = "Hari ini";
            } else if (diffDays === 1) {
                dateLabel = "Kemarin";
            } else {
                const dayName = dayNames[messageDate.getDay()];
                const date = messageDate.getDate();
                const monthName = monthNames[messageDate.getMonth()];
                dateLabel = `${dayName}, ${date} ${monthName}`;
            }

            if (!acc[dateLabel]) {
                acc[dateLabel] = [];
            }
            acc[dateLabel].push(message);
            return acc;
        }, {});
    }

    getShortMessage = () => {
        this.props.request('admin/message-short/list', {}, 'POST')
            .then((response) => {
                if(response.success){
                    const data = response.data;
                    this.setState({ dataShortMessage: data });
                }
            })

    }

    render() {
        const sortedMessages = [...this.state.messagesData].sort((a, b) => new Date(a.sendedAt) - new Date(b.sendedAt));
        const groupedMessages = this.groupMessagesByDay(sortedMessages);

        const nonAdminParticipants = this.props.participants.find(
            (member) => member.credential !== "cs" && member.credential !== "admin"
        );

        const selectedOptions = (this.state.dataShortMessage || [])
            .filter(item => item && item.message_id)
            .map(item => ({
                value: item.message_id,
                label: item.message_short
            }));

        return (
            <div className="card p-0 mb-0">
                <div className="card h-150 mb-0 d-flex justify-content-start align-items-start text-center">
                    <div className="card w-100 mb-0 border-0 rounded">
                        <div className="d-flex justify-content-between px-4 py-3 border-bottom">
                            <div className="d-flex align-items-start">
                                {
                                    nonAdminParticipants?.image ? (
                                        <img
                                            width={50}
                                            height={50}
                                            onError={(event) => {
                                                event.target.onerror = null;
                                                event.target.src = "";
                                                event.target.style.display = "none";
                                            }}
                                            src={nonAdminParticipants.image}
                                            alt="Company Logo"
                                            className="rounded-circle mr-3"
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50%",
                                                backgroundColor: "#1890ff",
                                                color: "white",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold",
                                                fontSize: "18px"
                                            }}
                                            className="mr-3"
                                        >
                                            {nonAdminParticipants.name?.charAt(0).toUpperCase() || "?"}
                                        </div>
                                    )
                                }

                                <div>
                                    <p className="mb-0 fw-semibold d-flex align-items-start text-dark" style={{fontSize: '15px'}}>
                                        {nonAdminParticipants?.name}
                                    </p>
                                    {this.state.isTyping ? (
                                        <p className="mb-0 text-muted d-flex align-items-start">
                                            Sedang mengetik...
                                        </p>
                                    ):(
                                        nonAdminParticipants.isOnline === true ? (
                                            < p className="mb-0 d-flex align-items-center" style={{color: '#0077de'}}>
                                                Online
                                            </p>
                                        ): (
                                            <p className="mb-0 text-muted d-flex align-items-start">
                                                Terakhir dilihat&nbsp;{moment(this.props.conversation.lastChatDate).locale('id').fromNow()}
                                            </p>
                                        )
                                    )}
                                </div>
                            </div>

                            <div className="d-flex align-items-center">
                                <img
                                    src={close}
                                    alt="close"
                                    width={20}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        this.props.handleClose()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="w-100 p-0">
                        <div
                            className="hide-scrollbar card-body w-100 p-0"
                            style={{
                                height: '345px',
                                overflowY: 'auto',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {this.state.messagesData.length === 0 ? (
                                <div className="d-flex justify-content-center align-items-center text-center text-secondary gap-2 py-2 px-3">
                                    <p className="d-flex justify-content-center align-items-center text-center mb-0 fw-semibold px-2"
                                       style={{fontSize: '14px'}}>
                                        No Chat!
                                    </p>
                                </div>
                            ) : (
                                Object.keys(groupedMessages).map((date) => (
                                    <>
                                        <div className="d-flex align-items-center text-secondary gap-2 py-2 px-3">
                                            <hr className="flex-grow-1 border-top border-gray-200 my-0"/>
                                            <p className="mb-0 fw-semibold px-2" style={{fontSize: '13px'}}>
                                                {date}
                                            </p>
                                            <hr className="flex-grow-1 border-top border-gray-200 my-0"/>
                                        </div>
                                        {groupedMessages[date].map((message) => (
                                            <div
                                                key={message._id || message.id}
                                                className={`${this.isSender(message.userID) ? 'sender' : ''}`}
                                            >
                                                <div
                                                    className={`col text-white ${this.isSender(message.userID) ? "d-flex justify-content-end" : "d-flex justify-content-start"}`}>
                                                    <div
                                                        className={`d-flex flex-column ${this.isSender(message.userID) ? "align-items-end" : " align-items-start"}`}>
                                                        <div
                                                            className="p-1"
                                                            style={{
                                                                backgroundColor: this.isSender(message.userID) ? '#1890ff' : '#F5F5F5',
                                                                maxWidth: message.images.length > 0 ? '108px' : '400px',
                                                                borderTopLeftRadius: '12px',
                                                                borderTopRightRadius: '12px',
                                                                borderBottomLeftRadius: this.isSender(message.userID) ? '12px' : '0px',
                                                                borderBottomRightRadius: this.isSender(message.userID) ? '0px' : '12px',
                                                            }}
                                                        >
                                                            {Array.isArray(message.images) &&
                                                            message.images.length > 0 ? (
                                                                <p className="mb-0" style={{
                                                                    fontSize: '14px',
                                                                    color: this.isSender(message.userID) ? '#FFFFFF' : '#11335f',
                                                                    textAlign: "left"
                                                                }}>
                                                                    <div style={{maxWidth: "100px"}}>
                                                                        <img
                                                                            src={`${IMG_MESSAGE_HOST}${message.images}`}
                                                                            alt={message.images}
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                marginTop: '0px',
                                                                                borderRadius: '10px'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    {message.text}
                                                                </p>
                                                            ) : (
                                                                <p
                                                                    className="p-1"
                                                                    style={{
                                                                        fontSize: '14px',
                                                                        color: this.isSender(message.userID) ? '#FFFFFF' : '#1d3a57',
                                                                        textAlign: "left"
                                                                    }}
                                                                >
                                                                    {message.text}
                                                                </p>
                                                            )
                                                            }
                                                        </div>

                                                        <div className="d-flex align-items-center gap-1 mb-2">
                                                            <p className="mb-0 text-muted mr-1"
                                                               style={{fontSize: '12px'}}>
                                                                {this.getTimeFromMessage(message.sendedAt)}
                                                            </p>
                                                            {this.isSender(message.userID) && (
                                                                message.isRead === true ?
                                                                    <img src={read} width={16} alt="Read status"/>
                                                                    :
                                                                    <img src={unread} width={16} alt="Read status"/>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ))
                            )}
                            <div ref={this.messagesEndRef}/>
                            <div
                                className="w-100"
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    backgroundColor: '#fff',
                                    zIndex: 10,
                                    marginTop: 'auto'
                                }}
                            >
                                <div className="d-flex justify-content-start align-items-center gap-2 py-2 px-3">
                                    <button
                                        className="d-flex flex-row align-items-center px-2 py-1 btn-short-toggle"
                                        onClick={() =>
                                            this.setState({openShortMessage: !this.state.openShortMessage})
                                        }
                                    >
                                        <img
                                            alt=""
                                            src={this.state.openShortMessage ? arrowDown : arrowUp}
                                            style={{width: "10px", height: "10px", color: "#1890ff"}}
                                            className="izin-btn"
                                        />
                                        <span className="sort-message px-2">
                                            {this.state.openShortMessage ? "Close" : "Short Message"}
                                        </span>
                                    </button>
                                </div>

                                {this.state.openShortMessage && (
                                    <div
                                        className="d-flex justify-content-start align-items-center pt-0 px-3 text-secondary">
                                        <div className="d-flex align-items-center justify-content-center px-2 ml-1">
                                            <FontAwesomeIcon
                                                onClick={() => this.setState({addShortMessage: true})}
                                                icon={faPlus}
                                                style={{fontSize: 12, cursor: "pointer", color: "#1890ff"}}
                                            />
                                        </div>

                                        <div
                                            className="hide-scrollbar card-body w-100 p-0"
                                            style={{
                                                height: '43px',
                                                overflowX: 'auto',
                                                whiteSpace: 'nowrap',
                                                display: 'flex',
                                                alignItems: 'center',
                                                paddingRight: '12px'
                                            }}
                                        >
                                            {selectedOptions.map((option, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => this.sendChat(option.label)}
                                                    className="px-3 py-1 mx-1"
                                                    style={{
                                                        border: "1px solid #1890ff",
                                                        borderRadius: "8px",
                                                        backgroundColor: "transparent",
                                                        color: "#1890ff",
                                                        fontSize: "14px",
                                                        cursor: "pointer",
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    {option.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="card w-100 mb-0 border-top-0 rounded position-relative">
                        {this.state.openFile && (
                            <div
                                className="position-absolute p-2 rounded"
                                style={{
                                    backgroundColor: "#F5F5F5",
                                    top: '-105px',
                                    left: '15px',
                                    zIndex: 999,
                                    width: '120px'
                                }}
                            >
                                <ImgCrop useRatio={true} width={250} height={250}>
                                    <Upload
                                        action="http://localhost:8000/"
                                        listType="picture-card"
                                        fileList={this.state.fileList}
                                        onChange={(file) => {
                                            this.setState({fileList: file.fileList});

                                            if (file.fileList.length > 0) {
                                                let files = file.file.originFileObj;
                                                let reader = new FileReader();

                                                reader.readAsDataURL(files);
                                                reader.onloadend = () => {
                                                    this.setState({
                                                        image: {
                                                            name: file.file.name,
                                                            file: reader.result,
                                                        },
                                                    });
                                                };
                                            } else {
                                                this.setState({image: []});
                                            }
                                        }}
                                    >
                                        {this.state.fileList.length >= 1 ? null : "+ Add image"}
                                    </Upload>
                                </ImgCrop>
                            </div>
                        )}
                        {this.state.openEmot && (
                            <div
                                className="position-absolute p-2 rounded"
                                style={{
                                    top: '-295px',
                                    right: '205px',
                                    zIndex: 999,
                                    width: '120px'
                                }}
                            >
                                <EmojiPicker onEmojiClick={this.handleEmojiClick} style={{ width: '300px', height: '300px' }} />
                            </div>
                        )}
                        <div className="d-flex justify-content-between p-3 border-top">
                            <div className="d-flex align-items-center w-100">
                                <button
                                    className="d-flex align-items-center w-100 mr-2 px-0"
                                    style={{
                                        border: "none",
                                        borderRadius: '8px',
                                        backgroundColor: "#F5F5F5"
                                    }}
                                >
                                    <img
                                        src={attach}
                                        style={{
                                            marginRight: "10px",
                                            marginLeft: "10px",
                                            cursor: "pointer"
                                        }}
                                        width={20}
                                        alt="attach"
                                        onClick={() => this.setState({ openFile: !this.state.openFile, openEmot: false })}
                                    />

                                    <textarea
                                        name="text"
                                        rows={1}
                                        className="form-control px-0"
                                        style={{
                                            border: "none",
                                            outline: "none",
                                            boxShadow: "none",
                                            backgroundColor: "#F5F5F5"
                                        }}
                                        placeholder="Type a message here..."
                                        value={this.state.text}
                                        onChange={this.handleInputChange}
                                        onClick={() => this.setState({ openEmot: false })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                this.sendChat();
                                            }
                                        }}
                                    />

                                    <img
                                        src={emoji}
                                        style={{
                                            marginRight: "10px",
                                            marginLeft: "10px",
                                            cursor: "pointer"
                                        }}
                                        width={20}
                                        alt="emoji"
                                        onClick={() => this.setState({ openEmot: !this.state.openEmot, openFile: false })}
                                    />
                                </button>

                                <button
                                    className="btn d-flex align-items-center justify-content-center"
                                    disabled={
                                        (!this.state.text.trim()) && (!this.state.image?.file || this.state.image.file === "")
                                    }
                                    style={{
                                        width: '25px',
                                        height: '35px',
                                        backgroundColor: (this.state.text.trim() || this.state.image?.file) ? '#1890ff' : '#96bcff',
                                        border: 'none',
                                        cursor: (this.state.text.trim() || this.state.image?.file) ? 'pointer' : 'not-allowed'
                                    }}
                                    onClick={() => this.sendChat()}
                                >
                                    <img src={send} width={20} alt="send"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.addShortMessage ? (
                    <Modal style={{width: "800px"}} showOverlay={true} showCloseButton={false}>
                        <Modal.Header>
                            <Modal.Title style={{fontWeight: "bold"}}>
                                Tambah Pesan Singkat
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <CreatableSelect
                                isMulti
                                isClearable={false}
                                value={selectedOptions}
                                onChange={(selected, actionMeta) => {
                                    if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
                                        const removed = actionMeta.removedValue;
                                        this.handleDelete(removed.value);
                                    }

                                    this.setState({
                                        dataShortMessage: selected.map(item => ({
                                            message_id: item.value,
                                            message_short: item.label
                                        }))
                                    });
                                }}
                                onCreateOption={(inputValue) => {
                                    this.handleAdd(inputValue);
                                }}
                                components={{
                                    DropdownIndicator: () => null
                                }}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button1 onClick={() => this.toggleModal()}>Close</Button1>
                        </Modal.Footer>
                    </Modal>
                ) : null
                }
            </div>
        );
    }
}